export default __webpack_public_path__ + "static/media/r_wdt_c_0.3d915216.mp3";